export default '/builds/vistaprint-org/expert-services/frontend/node_modules/next/dist/compiled/gzip-size'